import { HTMLtoText } from 'utils/text';

// Only trigger search after at least MIN_CHARACTERS are typed
export const MIN_CHARACTERS = 3;

// Only show MAX_RESULTS_PER_CATEGORY in the search preview
export const MAX_RESULTS_PER_CATEGORY = 3;

// This is necessary because the semantic-ui-react lib will warn if we pass unknown props for
// custom render. Reference: https://github.com/Semantic-Org/Semantic-UI-React/issues/1141
export const encodeImage = (id, photoAvailable) => `${encodeURIComponent(id)}#${(photoAvailable === true).toString()}`;

// If array is bigger than max results allowed, add a special entry for displaying a "Show all results" link
export const addShowAllEntry = (numberOfResults, onClick) => {
  return numberOfResults > MAX_RESULTS_PER_CATEGORY ? { key: 'showAll', type: "showAll", onClick } : [];
};

export function determineServiceName(name, serviceDisplayName, isStudent) {
  if (isStudent && serviceDisplayName) {
    return serviceDisplayName;
  }
  else if (isStudent || !serviceDisplayName) {
    return name;
  }
  return name + " (" + serviceDisplayName + ")";
}

export const formatData = ({connections, services}, isStudent, onShowAllClick) => {
  if ( connections.length === 0 && services.length === 0 ) return []; // Empty results
  return {
    connections: {
      name: "People",
      results: connections
        .slice(0, MAX_RESULTS_PER_CATEGORY)
        .map(({fullName, roles, personId, title, photoAvailable, uuid}) => ({
          id: personId,
          title: fullName,
          description: title ? title : roles.join(", "),
          type: "connection",
          image: encodeImage(uuid, photoAvailable)
        }))
        .concat(addShowAllEntry(connections.length, onShowAllClick))
    },
    services: {
      name: "Services",
      results: services
        .slice(0, MAX_RESULTS_PER_CATEGORY)
        .map(({name, serviceDisplayName, location, id, uuid}) => ({
          id,
          title: determineServiceName(name, serviceDisplayName, isStudent),
          description: HTMLtoText(location),
          type: "service",
          image: encodeImage(uuid, true)
        }))
        .concat(addShowAllEntry(services.length, onShowAllClick))
    }
  }
};
